import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import axios from "../../utils/networkHandler";
export const tokenConfig = (getState) => {
  const token = getState().auth.accessToken;

  const config = {
    headers: {},
  };

  if (token) {
    config.headers["Authorization"] = `Bearer ${token}`;
  }

  return config;
};

// Fetch Top Board
export const getTopBoard = createAsyncThunk(
  'campaign/top-board',
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign-top-board`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch Advertiser information
export const getAdvertiserInfo = createAsyncThunk(
  'campaign/advertiser-info',
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/all-advertisers`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Create Campaign
export const createCampaign = createAsyncThunk(
  "/admin/campaign-create",
  async (form, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post("/admin/campaign-create", form, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Approve/Reject campaign
export const approveRejectCampaign = createAsyncThunk(
  "/admin/campaign-approve-reject",
  async ({ id, state, publisherCPA, campaignCPA, note }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(`/admin/campaign-state/${id}`, {  state, publisherCPA, campaignCPA, note }, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch all campaigns
export const getAllCampaigns = createAsyncThunk(
  "/admin/all-campaign",
  async (
    { page, rowsPerPage, name, state, status, startDate, endDate },
    { getState, rejectWithValue }
  ) => {
    try {
      const config = tokenConfig(getState);
      let params = `page=${page + 1}&limit=${rowsPerPage}`;
      if (name) {
        params += `&name=${encodeURIComponent(name)}`;
      }
      if (state) {
        params += `&state=${encodeURIComponent(state)}`;
      }
      if (status) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      if (status === false) {
        params += `&status=${encodeURIComponent(status)}`;
      }
      if (startDate) {
        params += `&startDate=${encodeURIComponent(startDate)}`;
      }
      if (endDate) {
          params += `&endDate=${encodeURIComponent(endDate)}`;
        }
        //console.log(params)
      const response = await axios.get(`/admin/all-campaign?${params}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Fetch campaign by ID
export const getCampaignById = createAsyncThunk(
  "admin/campaign/getById",
  async (campaignId, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign/${campaignId}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Update campaign
export const updateCampaign = createAsyncThunk(
  "admin/campaign/update",
  async ({ campaignId, form }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(`/admin/campaign/${campaignId}`, form, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Campaign Payment
export const createCampaignPayment = createAsyncThunk(
  "admin/billing",
  async (form, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post("/admin/campaign-billing", form, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get Bill
export const getBill = createAsyncThunk(
  "/admin/campaign-bill",
  async (_, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get("/campaign/company-account", config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Pause and resume campaign
export const statusCampaign = createAsyncThunk(
  "/admin/status-campaign",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(`/admin/campaign-status/${id}`, {}, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Get campaign cpa by id
export const getCpaByCampaignId = createAsyncThunk(
  "admin/cpa/getById",
  async (campaignId, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign-cpa/${campaignId}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

// Update campaign cpa
export const updateCampaignCpa = createAsyncThunk(
  "/admin/update-campaign-cpa",
  async ({ id, costPerUserCampaign, costPerUserPublisher }, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.put(`/admin/update-campaign-cpa/${id}`, { costPerUserCampaign, costPerUserPublisher }, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  });

    //Create Postback Settings
export const createPostbackSettings = createAsyncThunk(
  "admin/create-postback-settings",
  async ({id, formData}, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.post(`/admin/campaign-publisher-postback-settings?staticId=${id}`, formData, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

//Get Postback Settings
export const getPostbackSettings = createAsyncThunk(
  "admin/postback-settings",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/campaign-publisher-postback-settings/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
)

// Get Campaign Link by id
export const getCampaignLink = createAsyncThunk(
  "campaign/link/getById",
  async (id, { getState, rejectWithValue }) => {
    try {
      const config = tokenConfig(getState);
      const response = await axios.get(`/admin/publishers-campaign-links/${id}`, config);
      return response.data;
    } catch (error) {
      if (!error.response) {
        throw error;
      }
      return rejectWithValue(error.response.data);
    }
  }
);

const campaignSlice = createSlice({
  name: "campaign",
  initialState: {
    loading: false,
    topBoard: {},
    advertiserInfo: [],
    campaigns: [],
    campaignCpa: {},
    budget: null,
    userId: null,
    campaignId: null,
    bill: [],
    campaign: null,
    campaignLink: [],
    meta: null,
    success: null,
    error: null,
    createSuccess: false,
    postbackSetting: {
      timeInterval: "0",
      range: "0",
      pbPublisher: "0",
      pbMetaClick: "0",
      staticId: "0"
    },
  },
  extraReducers: (builder) => {
    builder
      //get-topboard
      .addCase(getTopBoard.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getTopBoard.fulfilled, (state, action) => {
        state.loading = false;
        state.topBoard = action.payload.data;
      })
      .addCase(getTopBoard.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch topboard";
      })
      //get-advertiser-info
      .addCase(getAdvertiserInfo.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAdvertiserInfo.fulfilled, (state, action) => {
        state.loading = false;
        state.advertiserInfo = action.payload.data;
      })
      .addCase(getAdvertiserInfo.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch advertiser info";
      })
      //create-campaign
      .addCase(createCampaign.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(createCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.createSuccess = true;
        state.budget = action.payload?.data.budget;
        state.userId = action.payload?.data.userId;
        state.campaignId = action.payload?.data.campaignId;

        localStorage.setItem(
          "campaignBudget",
          JSON.stringify(action.payload?.data.budget)
        );
        localStorage.setItem(
          "userId",
          JSON.stringify(action.payload?.data.userId)
        );
        localStorage.setItem(
          "campaignId",
          JSON.stringify(action.payload?.data.campaignId)
          );
      })
      .addCase(createCampaign.rejected, (state, action) => {
        state.loading = false;
        state.createSuccess = false;
        state.error = action.payload?.message || "An error occurred";
      })
      //approve/reject campaign
      .addCase(approveRejectCampaign.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(approveRejectCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(approveRejectCampaign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "An error occurred";
      })
      //get-all-campaign
      .addCase(getAllCampaigns.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getAllCampaigns.fulfilled, (state, action) => {
        state.loading = false;
        state.campaigns = action.payload.data;
        state.meta = action.payload.meta; // Store pagination meta
      })
      .addCase(getAllCampaigns.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch campaigns";
      })
      //get-campaign-by-id
      .addCase(getCampaignById.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCampaignById.fulfilled, (state, action) => {
        state.loading = false;
        state.campaign = action.payload.data;
      })
      .addCase(getCampaignById.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch campaign";
      })
      //update-campaign
      .addCase(updateCampaign.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(updateCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.budget = action.payload?.data.budget;

        localStorage.setItem(
          "campaignBudget",
          JSON.stringify(action.payload?.data.budget)
        );
      })
      .addCase(updateCampaign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update campaign";
      })
      //create-payment
      .addCase(createCampaignPayment.pending, (state) => {
        state.loading = true;
        state.success = null;
        state.error = null;
      })
      .addCase(createCampaignPayment.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
        state.budget = 0;
        localStorage.setItem("campaignBudget", JSON.stringify(0));
      })
      .addCase(createCampaignPayment.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "An error occurred";
      })
      //get-bill
      .addCase(getBill.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getBill.fulfilled, (state, action) => {
        state.loading = false;
        state.bill = action.payload.data;
      })
      .addCase(getBill.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch bill";
      })
      //pause-resume-campaign
      .addCase(statusCampaign.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(statusCampaign.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(statusCampaign.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "An error occurred";
      })
      //get-cpa-by-campaign-id
      .addCase(getCpaByCampaignId.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(getCpaByCampaignId.fulfilled, (state, action) => {
        state.loading = false;
        state.campaignCpa = action.payload.data;
      })
      .addCase(getCpaByCampaignId.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to fetch CPA";
      })
      //update-campaign-cpa
      .addCase(updateCampaignCpa.pending, (state) => {
        state.loading = true;
        state.error = null;
      })
      .addCase(updateCampaignCpa.fulfilled, (state, action) => {
        state.loading = false;
        state.success = action.payload.message;
      })
      .addCase(updateCampaignCpa.rejected, (state, action) => {
        state.loading = false;
        state.error = action.payload?.message || "Failed to update CPA";
      })
      //create-postback-settings
      .addCase(createPostbackSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(createPostbackSettings.fulfilled, (state, action) => {
        state.loading = false;
        console.log("Postback settings created successfully:", action.payload);
      })
      .addCase(createPostbackSettings.rejected, (state, action) => {
        state.loading = false;
        console.error("Error creating postback settings:", action.payload);
      })
      //get-postback-settings
      .addCase(getPostbackSettings.pending, (state) => {
        state.loading = true;
      })
      .addCase(getPostbackSettings.fulfilled, (state, action) => {
        state.loading = false;
        state.postbackSetting = action.payload.data;
      })
      .addCase(getPostbackSettings.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching postback settings:", action.payload);
      })
      //get-publisher-link-by-id
      .addCase(getCampaignLink.pending, (state) => {
        state.loading = true;
      })
      .addCase(getCampaignLink.fulfilled, (state, action) => {
        state.loading = false;
        state.campaignLink = action.payload.data;
      })
      .addCase(getCampaignLink.rejected, (state, action) => {
        state.loading = false;
        console.error("Error fetching publisher link by ID:", action.payload);
      })
  },
});

export default campaignSlice.reducer;
